import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const UserContext = createContext(null);

export const useUserContext = () => {
	const context = useContext(UserContext);

	if (context === null) {
		throw new Error('useUserContext must be used within a UserProvider');
	}

	return context;
};

export const UserProvider = ({ user, children }) => (
	<UserContext.Provider value={{ user }}>{children}</UserContext.Provider>
);

UserProvider.propTypes = {
	user: PropTypes.object,
	children: PropTypes.node.isRequired,
};

export default UserContext;
